import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-450cc8a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "item_box" }
const _hoisted_3 = { class: "item_txt" }
const _hoisted_4 = { class: "mover_box" }

import { ref, watch, unref } from 'vue';
import { AnswerListClass } from '../type';
import { VueDraggableNext } from 'vue-draggable-next';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderModal',
  props: {
    modelValue: null
  },
  emits: ['updata:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: AnswerListClass[] };

const draggable = VueDraggableNext;


const list = ref<AnswerListClass[]>([]);

list.value = unref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    list.value = unref(props.modelValue);
  }
);

const changeList = () => {
  emit('updata:modelValue', list.value);
};

const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(draggable), _mergeProps({
      handle: ".mover",
      list: list.value
    }, dragOptions.value, {
      onDrop: _unref(dragDrop),
      onChange: changeList
    }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, "题目" + _toDisplayString(index + 1) + "：  " + _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_svg_icon, {
                  "icon-class": "drag_icon",
                  class: "mover"
                }, null, 512), [
                  [_vShow, list.value.length > 1]
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 16, ["list", "onDrop"])
  ]))
}
}

})